<template>
  <div class="agent-container">
    <el-card class="box-card">
      <!-- 添加页面标题区域 -->
      <div class="page-header">
        <div class="title">
          <i class="el-icon-user-solid"></i>
          <span>代理商管理</span>
        </div>
      </div>

      <!-- 搜索区域 -->
      <div class="filter-container">
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="代理商名称">
            <el-input
              v-model="queryParams.agentName"
              placeholder="请输入代理商名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="代理商类型">
            <el-select
              v-model="queryParams.agentType"
              placeholder="请选择代理商类型"
              clearable
              size="small"
            >
              <el-option label="全部" :value="-1" />
              <el-option label="代理" :value="1" />
              <el-option label="自营" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="queryParams.agentStatus"
              placeholder="请选择状态"
              clearable
              size="small"
            >
              <el-option label="全部" :value="-1" />
              <el-option label="启用" :value="1" />
              <el-option label="禁用" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="handleQuery"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh"
              size="small"
              @click="resetQuery"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="operation-container">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleAdd"
        >新增代理商</el-button>
        <!-- <el-button
          type="danger"
          icon="el-icon-delete"
          size="small"
          :disabled="selectedIds.length === 0"
          @click="handleBatchDelete"
        >批量删除</el-button> -->
      </div>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="agentList"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55" align="center" /> -->
        <el-table-column label="代理商名称" prop="agentName" align="center"   v-loading="tableLoading"
        element-loading-text="加载中...">
          <template slot-scope="scope">
            <el-button 
              type="text"
              @click="handleAgentClick(scope.row)"
            >{{ scope.row.agentName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="代理商类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.agentType === 1 ? '代理' : '自营' }}
          </template>
        </el-table-column>
        <el-table-column label="负责人" prop="charge" align="center" />
        <el-table-column label="负责人电话" prop="chargePhone" align="center" />
        <el-table-column label="办公电话" prop="phone" align="center" />
        <!-- <el-table-column label="联系地址" prop="contactAddr" align="center" show-overflow-tooltip /> -->

        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-document"
              @click="handleFiles(scope.row)"
            >文件</el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParams.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>

      <!-- 代理商表单对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="代理商名称" prop="agentName">
            <el-input v-model="form.agentName" placeholder="请输入代理商名称" />
          </el-form-item>
          <el-form-item label="代理商类型" prop="agentType">
            <el-select v-model="form.agentType" placeholder="请选择代理商类型">
              <el-option label="代理" :value="1" />
              <el-option label="自营" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="上级代理商" prop="parentId" v-if="form.agentType === 2">
            <el-select 
              v-model="form.parentId"
              filterable
              placeholder="请选择上级代理商"
            >
              <el-option
                v-for="item in parentOptions"
                :key="item.agentId"
                :label="item.agentName"
                :value="item.agentId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="负责人" prop="charge">
            <el-input v-model="form.charge" placeholder="请输入负责人姓名" />
          </el-form-item>
          <el-form-item label="负责人电话" prop="chargePhone">
            <el-input v-model="form.chargePhone" placeholder="请输入负责人电话" />
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入联系人电话" />
          </el-form-item>
          <el-form-item label="联系地址" prop="contactAddr">
            <el-input v-model="form.contactAddr" placeholder="请输入联系地址" />
          </el-form-item>
          <el-form-item label="企业QQ" prop="qcId">
            <el-input v-model="form.qcId" placeholder="请输入企业QQ" />
          </el-form-item>
          <el-form-item label="办公电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入办公电话" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 代理商文件对话框 -->
      <el-dialog title="代理商文件" :visible.sync="fileDialogVisible" width="800px" append-to-body>
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="headers"
          :data="uploadData"
          :before-upload="beforeUpload"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          multiple
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
        </el-upload>
        
        <el-table :data="fileList" style="margin-top: 20px">
          <el-table-column label="文件名称" prop="fileName" />
          <el-table-column label="文件类型" prop="fileKind" width="100" />
          <el-table-column label="上传时间" prop="createdAt" width="180" />
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleDownload(scope.row)"
              >下载</el-button>
              <el-button
                type="text"
                size="small"
                @click="handleDeleteFile(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import moment from 'moment'

export default {
  name: 'Agent',
  data() {
    return {
      tableLoading: false,
      // 遮罩层
      loading: false,
      // 选中数组
      selectedIds: [],
      // 总条数
      total: 0,
      // 代理商表格数据
      agentList: [],
      // 上级代理商选项
      parentOptions: [],
      // 弹出层标题
      dialogTitle: '',
      // 是否显示弹出层
      dialogVisible: false,
      // 是否显示文件弹出层
      fileDialogVisible: false,
      // 查询参数
      queryParams: {
        page: 1,
        size: 10,
        agentName: '',
        agentStatus: -1,
        agentType: -1
      },
      // 表单参数
      form: {
        agentId: '',
        agentType: undefined,
        parentId: '0',
        agentName: '',
        phone: '',
        charge: '',
        chargePhone: '',
        contact: '',
        contactPhone: '',
        contactAddr: '',
        status: 1,
        qcId: ''
      },
      // 表单校验
      rules: {
        agentName: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' }
        ],
        agentType: [
          { required: true, message: '请选择代理商类型', trigger: 'change' }
        ],
        charge: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        chargePhone: [
          { required: true, message: '请输入负责人电话', trigger: 'blur' }
        ]
      },
      // 文件列表
      fileList: [],
      // 上传地址
      uploadUrl: process.env.VUE_APP_BASE_API + '/api/v1/agent-files/upload',
      // 上传请求头
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      // 上传参数
      uploadData: {
        agentId: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询代理商列表 */
    async getList() {
      try {
        this.loading = true
        const res = await request({
          url: '/api/v1/sale/agent/list',
          method: 'POST',
          data: {
            page: this.queryParams.page,
            size: this.queryParams.size,
            agentName: this.queryParams.agentName || '',
            agentStatus: this.queryParams.agentStatus,
            agentType: this.queryParams.agentType
          }
        })

        if (res.status === 1) {
          // 处理返回的数据
          this.agentList = res.data.map(item => ({
            agentId: item.AgentId,
            agentName: item.AgentName,
            agentType: item.AgentType,
            parentId: item.ParentId || '0',
            charge: item.Charge,
            chargePhone: item.ChargePhone,
            contact: item.Contact,
            contactPhone: item.ContactPhone,
            contactAddr: item.ContactAddr,
            status: item.Status,
            qcId: item.QcId || '',
            phone: item.Phone
          }))
          this.total = res.total || 0
        } else {
          this.$message.error(res.msg || '获取代理商列表失败')
        }
      } catch (error) {
        console.error('获取代理商列表错误:', error)
        this.$message.error('获取代理商列表失败')
      } finally {
        this.loading = false
      }
    },
    
    /** 查询上级代理商列表 */
    getParentOptions() {
      // request({
      //   url: '/api/v1/agents/parent-list',
      //   method: 'post'
      // }).then(response => {
      //   this.parentOptions = response.data
      // })
    },
    
    /** 搜索按钮操作 */
    async handleQuery() {
      try {
        this.loading = true
        const params = {
          page: this.queryParams.page,
          size: this.queryParams.size
        }
        
        // 修改搜索条件的判断逻辑
        if (this.queryParams.agentName) {
          params.agentName = this.queryParams.agentName.trim()
        }
        if (this.queryParams.agentStatus !== -1) {
          params.agentStatus = this.queryParams.agentStatus
        }
        // 修改代理商类型的搜索逻辑
        if (this.queryParams.agentType !== -1) {
          params.agentType = this.queryParams.agentType // 1=代理，2=自营
        }

        const res = await request({
          url: '/api/v1/sale/agent/list',
          method: 'POST',
          data: params
        })

        if (res.status === 1) {
          // 处理返回的数据
          this.agentList = res.data.map(item => ({
            ...item,
            // 确保代理商类型的值与搜索条件一致
            agentType: Number(item.AgentType), // 转换为数字确保类型一致
            agentName: item.AgentName,
            parentId: item.ParentId || '0',
            charge: item.Charge,
            chargePhone: item.ChargePhone,
            contact: item.Contact,
            contactPhone: item.ContactPhone,
            contactAddr: item.ContactAddr,
            status: item.Status,
            qcId: item.QcId || '',
            phone: item.Phone
          }))

          // 如果选择了特定类型，过滤结果
          if (this.queryParams.agentType !== -1) {
            this.agentList = this.agentList.filter(item => 
              item.agentType === this.queryParams.agentType
            )
          }

          this.total = res.total || 0
        } else {
          this.$message.error(res.msg || '查询失败')
          this.agentList = []
        }
      } catch (error) {
        console.error('查询错误:', error)
        this.$message.error('查询失败')
        this.agentList = []
      } finally {
        this.loading = false
      }
    },
    
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        page: 1,
        size: 10,
        agentName: '',
        agentStatus: -1,
        agentType: -1  // 重置为���部
      }
      this.getList()
    },
    
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.getParentOptions()
      this.dialogTitle = '添加代理商'
      this.dialogVisible = true
    },
    
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.getParentOptions()
      this.form = {
        agentId: row.agentId,
        agentType: row.agentType,
        parentId: row.parentId,
        agentName: row.agentName,
        phone: row.phone,
        charge: row.charge,
        chargePhone: row.chargePhone,
        contact: row.contact,
        contactPhone: row.contactPhone,
        contactAddr: row.contactAddr,
        status: row.status,
        qcId: row.qcId
      }
      this.dialogTitle = '修改代理商'
      this.dialogVisible = true
    },
    
    /** 文件按钮操作 */
    handleFiles(row) {
      this.uploadData.agentId = row.agentId
      this.getFileList(row.agentId)
      this.fileDialogVisible = true
    },
    
    /** 获取文件列表 */
    getFileList(agentId) {
      request({
        url: '/api/v1/sale/agent/list',
        method: 'get',
        params: { agentId }
      }).then(response => {
        this.fileList = response.data
      })
    },
    
    /** 删除按钮操作 */
    async handleDelete(row) {
      try {
        await this.$confirm('是否确认删除该代理商?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: '/api/v1/sale/agent/delete',
          method: 'POST',
          data: {
            agentId: row.agentId  // 只需要传入代理商ID
          }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getList() // 刷新列表
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') { // 排除取消操作的错误
          console.error('删除代理商错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    
    // /** 批量删除操作 */
    // handleBatchDelete() {
    //   const agentIds = this.selectedIds.map(item => item.agentId)
    //   this.$confirm('是否确认删除选中的代理商?', '警告', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     return request({
    //       url: '/api/v1/agents/batch-delete',
    //       method: 'post',
    //       data: { agentIds }
    //     })
    //   }).then(() => {
    //     this.getList()
    //     this.$message.success('批量删除成功')
    //   })
    // },
    
    /** 表单重置 */
    reset() {
      this.form = {
        agentId: '',
        agentType: undefined,
        parentId: '0',
        agentName: '',
        phone: '',
        charge: '',
        chargePhone: '',
        contact: '',
        contactPhone: '',
        contactAddr: '',
        status: 1,
        qcId: ''
      }
      this.$refs.form && this.$refs.form.resetFields()
    },
    
    /** 提交按钮 */
    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            // 构造符合接口要求的参数
            const params = {
              agentId: this.form.agentId || '', // 新增时为空，编辑时传入ID
              agentType: this.form.agentType, // 1-代理商 2-自营
              parentId: this.form.parentId || '0',
              agentName: this.form.agentName,
              phone: this.form.phone || '',
              charge: this.form.charge,
              chargePhone: this.form.chargePhone,
              contact: this.form.contact || '',
              contactPhone: this.form.contactPhone || '',
              contactAddr: this.form.contactAddr || '',
              status: this.form.status || 1
            }

            const res = await request({
              url: '/api/v1/sale/agent/save',
              method: 'POST',
              data: params
            })

            if (res.status === 1) {
              this.$message.success('保存成功')
              this.dialogVisible = false
              this.getList() // 刷新列表
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          } catch (error) {
            console.error('保存代理商错误:', error)
            this.$message.error('保存失败')
          }
        }
      })
    },
    
    /** 文件上传前的钩子 */
    beforeUpload(file) {
      const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传JPG/PNG/PDF格式文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!')
        return false
      }
      return true
    },
    
    /** 文件上传成功的钩子 */
    handleUploadSuccess(response, file) {
      this.$message.success('上传成功')
      this.getFileList(this.uploadData.agentId)
    },
    
    /** 文件上传失败的钩子 */
    handleUploadError() {
      this.$message.error('上传失败')
    },
    
    /** 文件下载操作 */
    handleDownload(row) {
      window.open(row.fileUrl)
    },
    
    /** 删除文件操作 */
    handleDeleteFile(row) {
      this.$confirm('是否确认删除该文件?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return request({
          url: '/api/v1/sale/agent/delete',
          method: 'post',
          data: { fileId: row.fileId }
        })
      }).then(() => {
        this.getFileList(this.uploadData.agentId)
        this.$message.success('删除成功')
      })
    },
    
    /** 多选框选中数据 */
    handleSelectionChange(selection) {
      this.selectedIds = selection
    },
    
    /** 每页显示条数变 */
    handleSizeChange(val) {
      this.queryParams.size = val
      this.getList()
    },
    
    /** 当前页改变 */
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    
    /** 状态修改 */
    handleStatusChange(row) {
      request({
        url: '/api/v1/agents/change-status',
        method: 'post',
        data: {
          agentId: row.agentId,
          status: row.status
        }
      }).then(() => {
        this.$message.success('状态修改成功')
      }).catch(() => {
        row.status = row.status === 1 ? 0 : 1
      })
    },
    
    /** 点击代理商名称跳转 */
    handleAgentClick(row) {
      this.$router.push({
        name: 'DealerManagement',
        params: { agentId: row.agentId },
        query: { agentName: row.agentName }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.agent-container {
  padding: 20px;

  .page-header {
    position: relative;
    height: 80px;
    margin: -10px -20px 30px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    overflow: hidden;

    /* 添加科技感背景 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
      background-size: 20px 20px;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
      animation: backgroundMove 20s linear infinite;
    }

    /* 添加动态光效 */
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -150%;
      width: 150%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.1),
        transparent
      );
      transform: skewX(-20deg);
      animation: shine 8s infinite;
    }

    .title {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      
      i {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #fff;
        backdrop-filter: blur(5px);
      }

      span {
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    }
  }

  /* 添加动画 */
  @keyframes backgroundMove {
    0% {
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    }
    100% {
      background-position: -20px -20px, -20px -10px, -10px -30px, -30px -20px;
    }
  }

  @keyframes shine {
    0% {
      left: -150%;
    }
    50% {
      left: 100%;
    }
    100% {
      left: 100%;
    }
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}
</style> 